"use strict";

const DEFAULT_EXPIRES = 30;

function set(name, value, options) {
	
	options = options || {};
	
	let s = "";
	let d;
	
	s += name + "=" + value;
	
	if (options.expires) {
		if (options.expires.constructor === Date) {
			d = options.expires;
		} else if (options.expires.constructor === Number) {
			d = new Date();
			d.setDate(d.getDate() + options.expires);
		}
	}
	else {
		d = new Date();
		d.setDate(d.getDate() + DEFAULT_EXPIRES);
	}
	
	s += "; expires="+d.toGMTString();
	
	if (options.domain) s += "; domain="+options.domain;
	if (options.path) s += "; path="+options.path;
	
	document.cookie = s;
}

/** @method: Cookie.get
	
	@arguments:
		@name: String
*/

function get(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
	  var c = ca[i];
	  while (c.charAt(0)==' ') c = c.substring(1);
	  if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
	}
	return "";
}

/** @method: Cookie.clear
	
	@arguments:
		@name: String
		@options: {
			@path: String
			@domain: String
		}
*/

function clear(name, options) {
	if (!name || !get(name)) return;
	options = options || {};
	set(name, '', {
		expires: new Date,
		path: options.path || null,
		domain: options.domain || null
	});			
};

export default {
	set: set,
	get: get,
	clear: clear
};


// WEBPACK FOOTER //
// ./~/vwa/cookie.js